import _ from 'underscore';
import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useFormService, FORM_STATES, FORM_EVENTS } from '@bingads-webui-react/form-core';
import { BasicDialog } from './basic-dialog';

export const CancelDialog = (props) => {
  const i18n = useContext(I18nContext);
  const { state, send } = useFormService();
  const showDialog = state.matches(FORM_STATES.CANCELING);
  const useConfig = useMemo(() => (_.isFunction(props.config) ? props.config : () => props.config), [props.config]);

  const {
    className = null,
    title = null,
    subText = null,
    content = null,
    confirmText = null,
    abortText = null,
    onConfirmFn = null,
    onCancelFn = null,
  } = useConfig(showDialog) || {};

  const onConfirm = useCallback(() => {
    if (onConfirmFn) {
      onConfirmFn();
    }
    send(FORM_EVENTS.CONFIRM_CANCEL);
  }, [onConfirmFn, send]);

  const onCancel = useCallback(() => {
    if (onCancelFn) {
      onCancelFn();
    }
    send(FORM_EVENTS.ABORT_CANCEL);
  }, [onCancelFn, send]);

  return (
    <BasicDialog
      hidden={!showDialog}
      className={classNames('form-cancel-dialog', className)}
      title={title || i18n.getString(_TL_('Are you sure you want to exit?'))}
      subText={subText || i18n.getString(_TL_('You have unsaved changes that could be lost.'))}
      content={content}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText={confirmText}
      abortText={abortText}
    />
  );
};

CancelDialog.propTypes = {
  config: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

CancelDialog.defaultProps = {
  config: {},
};
